import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table } from 'semantic-ui-react';
import { Link } from 'nallian-shared-ui/lib/components';
import { FEATURE_TABS } from '../../constants';

const FeatureRolesTable = ({ roles, rootUrl }) => {
  const { t } = useTranslation();

  if (!roles.length) {
    return <div>{t('noRolesFound')}</div>;
  }

  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width="4">{t('name')}</Table.HeaderCell>
          <Table.HeaderCell width="4">{t('tag')}</Table.HeaderCell>
          <Table.HeaderCell width="4" />
          <Table.HeaderCell width="4" />
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {roles.map(r => (
          <Table.Row key={`role_${r.tag}`}>
            <Table.Cell width="4">
              <Link to={`${rootUrl}/roles/${r.id}/${FEATURE_TABS.DETAILS}`}>{r.name}</Link>
            </Table.Cell>
            <Table.Cell width="4">{r.tag}</Table.Cell>
            <Table.Cell width="4" />
            <Table.Cell width="4" />
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

FeatureRolesTable.propTypes = {
  rootUrl: PropTypes.string.isRequired,
  roles: PropTypes.array,
};

FeatureRolesTable.defaultProps = { roles: [] };

export default FeatureRolesTable;
